import { html } from 'lit';
import { query } from 'lit/decorators.js';
import { EndpointFilterController } from '../controller/EndpointFilterController';
import { uniqBy } from 'lodash';
import { SelectedOption } from '../../gzEnumList/types';
import { isEmpty } from '@nirvana/shared/basic-types/object';
import { GzEnumFilterWebComponent } from '../../gzEnumFilter/index';
import { GzEndpointListWebComponent } from '../../gzEndpointList/index';
import { GetEndpointsResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';

export class GzEndpointFilterWebComponent extends GzEnumFilterWebComponent {
  public controller: EndpointFilterController;
  public defaultValue: Array<string>;
  public overwriteList;
  public companyId: string;
  public selectedFilterOptions: SelectedOption[] = [];

  @query('#multiple-selection-list')
  public enumList!: GzEndpointListWebComponent;

  private dependencies: any;
  public specialValueSelected = false;
  public targetEndpoints = new Map<string, GetEndpointsResponse | undefined>();

  injectDependencies(dependencies) {
    if (this.dependencies) {
      return;
    }

    this.dependencies = dependencies;
    this.controller = new EndpointFilterController(this.dependencies, this);
  }

  public handleLoadingState(shouldShowLoading: boolean) {
    this.enumList.isLoading = shouldShowLoading;
    this.setActionButtonDisabledState(shouldShowLoading);
  }

  protected renderEnumList() {
    let optionList;

    if (this.enumList === null || this.enumList.filterOptions === null || this.overwriteList) {
      optionList = this.filterOptions;
      this.overwriteList = false;
    } else {
      optionList = this.filterOptions;
      optionList = uniqBy(optionList, JSON.stringify);
    }

    return html` <gz-endpoint-list
      id="multiple-selection-list"
      .filterOptions="${optionList}"
      searchPlaceholderString="${this.searchPlaceholderString}"
      noSearchResultsString="${this.noSearchResultsString}"
      listTitle="${this.listTitle}"
      .canSelectAll="${this.canSelectAll}"
      allItemsLabel="${this.allItemsLabel}"
      @optionChanged="${this.handleListOptionsChange}"
      class="enum-filter-list"
    ></gz-endpoint-list>`;
  }

  protected handleDropdownOpen() {
    if (this.isLoading || this.isError) {
      return;
    }

    const selectedValues = this.specialValueSelected
      ? this.controller.getSpecialSelectedOption()
      : this.enumList.getSelectedValuesFromFilterOptions();

    this.enumList.setSelectedOptions(selectedValues);
    super.handleDropdownOpen();
  }

  protected updateDropdownLabelWithSelectedValues(selectedOptions: SelectedOption[]) {
    const checkedOptions = isEmpty(selectedOptions) ? this.enumList.getCheckedOptions() : selectedOptions;

    this.dropdownMenu.label = this.label ?? '';

    if (isEmpty(checkedOptions)) {
      this.dropdownMenu.selectedValuesStrings = this.allItemsLabel;
      return;
    }

    const selectedOptionsText = checkedOptions.map(option => option.label).join(', ');
    this.dropdownMenu.selectedValuesStrings = selectedOptionsText;
  }

  public setCompanyId(companyId: string) {
    this.companyId = companyId;
  }

  public setActionButtonDisabledStateWhenLoading(isDisabled: boolean) {
    super.setActionButtonDisabledState(isDisabled);
  }
}
